module.exports = __webpack_public_path__ + "img/symbol_4.41f7e78c.png";